import { IOrder } from '@/models/order.model';
import { showApiErrors } from '@/utils';
import { createSlice, isFulfilled, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { TOrderFiltersValues } from '../helpers';
import {
  changeOrderStatus,
  getOrder,
  getOrders,
  deleteOrderFiles,
  addFilesToOrder,
  completeOrder,
} from './actionCreators';
import { initialState, ORDERS_SLICE_NAME, OrdersState } from './models';

export const slice = createSlice({
  name: ORDERS_SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    applyFilters(state: OrdersState, action: PayloadAction<TOrderFiltersValues>) {
      state.appliedFilters = { ...(state.appliedFilters || {}), ...action.payload };
    },

    setOrder(state: OrdersState, action: PayloadAction<IOrder | null>) {
      state.order = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrders.fulfilled, (state: OrdersState, action) => {
        const { payload, meta } = action;
        state.orders = payload.items;
        state.pagination = { ...payload.cursor, limit: meta.arg.limit };
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(isFulfilled(changeOrderStatus, completeOrder), (state: OrdersState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.error = null;
        state.order = payload;
        state.orders = (state.orders ?? []).map((order) => (order.PK === payload.PK ? payload : order));
      })
      .addMatcher(isFulfilled(deleteOrderFiles, addFilesToOrder, getOrder), (state: OrdersState, action) => {
        const { payload } = action;
        state.order = payload;
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(
        isPending(getOrders, getOrder, changeOrderStatus, deleteOrderFiles, addFilesToOrder, completeOrder),
        (state: OrdersState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(getOrders, getOrder, changeOrderStatus, deleteOrderFiles, addFilesToOrder, completeOrder),
        (state: OrdersState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export default slice.reducer;

export const { resetState, applyFilters, setOrder } = slice.actions;
